import { createAction, props } from '@ngrx/store';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { DynamicPagesEventTypes } from './dynamic-pages.reducer';

export const newEvent = createAction(
    '[DynamicPages] New Event',
    props<{ entityType: SystemEntity; eventType: DynamicPagesEventTypes }>(),
);
